// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__31T5N","rootSmall":"AddTileButton_rootSmall__2nCCY"};